var _rect, _ellipse, _path, _g, _g2, _rect2, _rect3, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderHolaFly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 384,
    viewBox: "0 0 522 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 324.766,
    width: 522,
    height: 2.04255,
    rx: 1,
    fill: "#E4E6EA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261,
    cy: 212.426,
    rx: 171.281,
    ry: 171.574,
    fill: "#292B2E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2654_29495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: -9,
    width: 344,
    height: 393
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7188 -8.17017H432.281V212.719C432.281 307.315 355.596 384 261 384C166.404 384 89.7188 307.315 89.7188 212.719V-8.17017Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2654_29495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.76,
    y: 10.2129,
    width: 210.657,
    height: 453.359,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.542 12.3989H172.458C164.007 12.3989 157.155 19.2497 157.155 27.7006V447.858C157.155 456.309 164.007 463.16 172.458 463.16H349.542C357.993 463.16 364.845 456.309 364.845 447.858V27.7006C364.845 19.2497 357.993 12.3989 349.542 12.3989ZM172.458 10.2129C162.799 10.2129 154.969 18.0424 154.969 27.7006V447.858C154.969 457.516 162.799 465.346 172.458 465.346H349.542C359.201 465.346 367.031 457.516 367.031 447.858V27.7006C367.031 18.0424 359.201 10.2129 349.542 10.2129H172.458Z",
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.607,
    cy: 26.6073,
    rx: 3.27932,
    ry: 3.27894,
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.769 27.7006H222.742V25.5146H281.769V27.7006Z",
    fill: "#292B2E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2654_29495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.0938,
    y: 204.255,
    width: 277.312,
    height: 98.0425,
    rx: 8,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.617,
    y: 243.064,
    width: 106.031,
    height: 8.17021,
    rx: 4.08511,
    fill: "#E4E6EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136.617,
    y: 255.319,
    width: 146.812,
    height: 8.17021,
    rx: 4.08511,
    fill: "#E4E6EA"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2654_29495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.719,
    y: 49.0212,
    width: 97.875,
    height: 122.553,
    rx: 8,
    fill: "#BFEBFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.076 269.617C103.824 269.617 101.705 269.186 99.7196 268.326C97.7342 267.465 96.0008 266.292 94.5192 264.808C93.0376 263.324 91.8671 261.588 91.0077 259.599C90.1484 257.61 89.7188 255.488 89.7188 253.232C89.7188 249.017 91.1043 245.366 93.8755 242.279C96.6456 239.192 100.12 237.411 104.298 236.936V239.563C100.86 240.038 98.0086 241.567 95.7424 244.149C93.4749 246.731 92.3412 249.759 92.3412 253.232C92.3412 257.061 93.6746 260.311 96.3415 262.983C99.0084 265.654 102.253 266.99 106.076 266.99C108.239 266.99 110.283 266.523 112.21 265.588C114.136 264.653 115.736 263.324 117.01 261.603L119.232 263.027C117.692 265.164 115.765 266.797 113.454 267.925C111.143 269.053 108.683 269.617 106.076 269.617ZM121.01 259.732L118.788 258.352C119.173 257.551 119.44 256.727 119.588 255.88C119.736 255.035 119.81 254.152 119.81 253.232C119.81 249.759 118.676 246.724 116.409 244.126C114.143 241.529 111.291 240.008 107.854 239.563V236.936C112.061 237.322 115.543 239.08 118.299 242.211C121.055 245.343 122.433 249.017 122.433 253.232C122.433 254.36 122.329 255.48 122.122 256.593C121.914 257.706 121.544 258.753 121.01 259.732Z",
    fill: "#292B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.811 126.386V111.33L428.405 93.9575L387.811 126.386Z",
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M387.811 126.386L393.579 117.466L428.33 93.9575L387.811 126.386Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387.725 114.407L371.109 105.136L428.372 93.9575L387.725 114.407Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M411.74 126.201L393.592 117.41L428.33 93.9575L413.078 125.734C412.838 126.233 412.239 126.442 411.74 126.201Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.218 127.16C293.715 126.787 293.142 126.599 292.496 126.599C291.207 126.599 290.563 127.399 290.563 128.999V131.444H295.585V136.198H290.563V154.04H285.518V136.198H282.106V131.444H285.518V128.365C285.518 126.282 286.085 124.644 287.22 123.451C288.355 122.259 289.764 121.663 291.445 121.663C292.818 121.663 293.919 121.867 294.745 122.274C295.407 122.601 295.946 122.952 296.366 123.327L294.218 127.16ZM249.785 154.038H255.488V122.614H249.785V154.038ZM238.948 148.012C237.776 149.322 236.311 149.978 234.552 149.978C232.764 149.978 231.299 149.33 230.156 148.035C229.013 146.741 228.442 145.084 228.442 143.066C228.442 141.078 229.013 139.437 230.156 138.142C231.299 136.847 232.764 136.199 234.552 136.199C236.311 136.199 237.776 136.847 238.948 138.142C240.12 139.437 240.706 141.078 240.706 143.066C240.706 145.054 240.12 146.702 238.948 148.012ZM240.4 132.765C238.67 131.712 236.722 131.184 234.553 131.184C232.414 131.184 230.472 131.712 228.729 132.765C226.985 133.82 225.622 135.25 224.64 137.057C223.658 138.864 223.168 140.867 223.168 143.065C223.168 145.264 223.658 147.274 224.64 149.096C225.622 150.918 226.977 152.356 228.707 153.41C230.436 154.464 232.384 154.991 234.553 154.991C236.722 154.991 238.67 154.464 240.4 153.41C242.129 152.356 243.492 150.918 244.488 149.096C245.484 147.274 245.983 145.264 245.983 143.065C245.983 140.867 245.484 138.864 244.488 137.057C243.492 135.25 242.129 133.82 240.4 132.765ZM304.922 154.038H299.218V122.614H304.922V154.038ZM325.312 131.184V142.764C325.312 144.611 324.851 146.033 323.927 147.032C323.004 148.031 321.795 148.531 320.3 148.531C318.893 148.531 317.807 148.122 317.046 147.305C316.283 146.487 315.902 145.11 315.902 143.172V131.184H310.626V144.081C310.626 147.29 311.336 149.682 312.758 151.255C314.18 152.83 316.137 153.617 318.629 153.617C320.182 153.617 321.472 153.352 322.498 152.822C323.524 152.293 324.447 151.513 325.268 150.483L325.312 150.62V153.026C325.312 154.903 324.851 156.348 323.927 157.363C323.004 158.377 321.736 158.884 320.124 158.884C317.914 158.884 316.468 158.041 315.78 156.364L311.42 158.678C312.008 159.809 312.79 160.779 313.77 161.586C315.367 162.903 317.485 163.561 320.124 163.561C323.406 163.561 325.972 162.6 327.819 160.678C329.666 158.755 330.589 156.189 330.589 152.981V131.184H325.312ZM272.922 146.451C272.922 147.747 272.489 148.763 271.622 149.501C270.754 150.239 269.678 150.607 268.393 150.607C267.167 150.607 266.203 150.344 265.501 149.817C264.798 149.29 264.447 148.59 264.447 147.716C264.447 146.783 264.768 146.068 265.411 145.571C266.054 145.074 267.078 144.72 268.483 144.509L272.922 143.831V146.451ZM275.658 133.285C273.894 131.884 271.667 131.184 268.976 131.184C266.345 131.184 264.283 131.749 262.788 132.878C261.305 133.998 260.25 135.69 259.621 137.95L264.422 138.827C264.63 137.798 265.048 137.003 265.68 136.447C266.383 135.83 267.422 135.521 268.797 135.521C271.547 135.521 272.922 136.892 272.922 139.632V139.903L268.124 140.58C264.835 141.032 262.542 141.913 261.241 143.223C259.941 144.533 259.291 146.137 259.291 148.034C259.291 149.42 259.634 150.639 260.322 151.693C261.009 152.748 261.936 153.561 263.102 154.133C264.268 154.704 265.553 154.991 266.958 154.991C269.858 154.991 271.936 154.103 273.191 152.326L273.774 154.358H278.303V139.542C278.303 136.771 277.421 134.685 275.658 133.285ZM198.723 136.339C204.88 137.57 209.309 136.989 212.158 134.594V122.614H217.463V154.038H212.158V140.571V140.168C209.968 141.201 207.397 141.721 204.423 141.721C202.665 141.721 200.765 141.539 198.723 141.178V154.038H193.42V139.934C192.723 139.734 192.013 139.52 191.289 139.286C187.485 138.061 182.605 138.659 180.501 139.562L179.438 134.883C182.484 133.828 187.91 133.195 192.666 134.728C192.92 134.81 193.17 134.888 193.42 134.965V122.614H198.723V135.498V136.339Z",
    fill: "#E6485C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2654_29495",
    x: 33.0938,
    y: 186.255,
    width: 325.312,
    height: 146.042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2654_29495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2654_29495",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2654_29495",
    x: 326.719,
    y: 31.0212,
    width: 145.875,
    height: 170.553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2654_29495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2654_29495",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderHolaFly);
export default __webpack_public_path__ + "static/media/loaderHolaFly.83a5809537ff1025d7ad5ade9aa604fb.svg";
export { ForwardRef as ReactComponent };